import { Component, Input, OnInit, TemplateRef, ViewChild,Output,EventEmitter } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SubscriptService } from '../../service/header.service';
import { DatePipe } from '@angular/common'
import { HttpClient } from '@angular/common/http';
import {  NbDialogService } from '@nebular/theme';
import { CurrencyPipe} from '@angular/common';
import * as _ from 'lodash';
import { Router } from '@angular/router';

@Component({
  selector: 'app-status-update-modal',
  templateUrl: './status-update-modal.component.html',
  styleUrls: ['./status-update-modal.component.scss']
})
export class StatusUpdateModalComponent implements OnInit {
  @Output() emitList = new EventEmitter();
  @Output() emitClose = new EventEmitter();
  @Input() info: {
    getURL: string;
    updateURL: string;
    eosNo: string;
    source: number;
  };

  //-----------------------彈窗----------------------------

  modalRef = null;  //彈窗鉤子
  PdModalRef = null;  //彈窗鉤子

  @ViewChild('Modal') Modal :TemplateRef<any>
  @ViewChild('PdModal') PdModal :TemplateRef<any>

  //基本資料
  USR_AccountInfo_ID: string;
  USR_EmployeeInfo_ID: string;
  ORG_Company_ID: number;
  ORG_Store_ID: number;
  authChangeSub:any;

  statusList: Status[]=[
    { ID:1, statusName: '訂單準備中', CanClick: true },
    { ID:2, statusName: '訂單完成', CanClick: false },
  ];

  statusHistory: StatusHistory[] = [
    { CreateBy: '1', statusName: '訂單準備中', CreateDate: '2024-04-15' },
    { CreateBy: '2', statusName: '訂單完成', CreateDate: '2024-04-15' },
    { CreateBy: '3', statusName: '訂單完成', CreateDate: '2024-04-15' },
    { CreateBy: '4', statusName: '訂單完成', CreateDate: '2024-04-15' },
    { CreateBy: '5', statusName: '訂單完成', CreateDate: '2024-04-15' },
  ];

  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private cookieService: CookieService,
  ) {
    this.USR_AccountInfo_ID = this.cookieService.get('USR_AccountInfo_ID') ? 
      "USR_AccountInfo_ID_"+this.cookieService.get('USR_AccountInfo_ID') :
        this.cookieService.get('USR_POSEmployeeInfo_ID') ?  
          "USR_POSEmployeeInfo_ID"+this.cookieService.get('USR_POSEmployeeInfo_ID') : null;
    this.USR_EmployeeInfo_ID = this.cookieService.get('USR_EmployeeInfo_ID')
    this.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'))
    let cookie_sid = this.cookieService.get('ORG_Store_ID')
    this.ORG_Store_ID= (cookie_sid && cookie_sid!='') ? parseInt(cookie_sid) : null
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    this.onOpen(this.info)

  }

  async onOpen(data){
    await this.get_EOS_Status_List(data) 
    await this.get_EOS_Status_History();
    this.modalRef = this.dialogService.open(this.Modal, {});
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });
  }


  //取得狀態清單
  get_EOS_Status_List(data): Promise<any> {
    return new Promise((resolve, reject) => {
    this.http.get<any>(data.getURL+`EOSNo=${data.eosNo}`,
    ).subscribe({
      next: data => {
        this.statusList = []
        data.LIST.forEach(element => {
          var item : Status;

          var item: Status = { 
            statusName: element.Name,  
            ID: element.ID, 
            CanClick: element.CanClick
          };
          this.statusList.push(item);
        });
        resolve(this.statusHistory);
      },
      error: error => {
        console.error('There was an error!', error);
        reject(error);
      }
    });
  });
}


  //更新狀態
  onStatusClick(ID: string) {
    const data = this.info
    this.http.post<any>(data.updateURL, {
      // USR_AccountInfo_ID: this.USR_AccountInfo_ID, //建立者,      
      EOSNo: data.eosNo,
      EOS_Status_ID: ID,
      LastUpdateBy : "USR_AccountInfo_ID_" + this.USR_AccountInfo_ID
    }).subscribe({
      next: data => {
        alert('更新狀態成功')
        this.onClose()
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });
  }

  
  //取得歷程紀錄
  get_EOS_Status_History(): Promise<any> {
    const data = this.info;
    return new Promise((resolve, reject) => {
      this.http.post<any>('api/EOS/OrderManage/WebGetEOSInfoRecord', {
        EOSNo: data.eosNo,
        Source: data.source,
        Page: 1,
        PerPage: 3,
      }).subscribe({
        next: data => {
          this.statusHistory = [];
          data.LIST.forEach(element => {
            var item: StatusHistory = { 
              statusName: element.StatusName,  
              CreateDate: element.CreateDate, 
              CreateBy: element.CreateBy
            };
            this.statusHistory.push(item);
          });
          resolve(this.statusHistory);
        },
        error: error => {
          console.error('There was an error!', error);
          reject(error);
        }
      });
    });
  }
  


  onClose(){
    this.modalRef.close()
  }


  //商品 明細
  @ViewChild('ShowDataMo_Tmp',{static:false}) ShowDataMo_Tmp 
  ShowDataMo = {
    EOSNo:null,
    source:null,
    isShow:false,
    onOpen:()=>{ 
      let my = this.ShowDataMo    
      my.EOSNo=this.info.eosNo
      my.source=this.info.source
      my.isShow = true
    },   
    onClose(v){
      this.isShow = false   
    }
  }

  
}

interface Status {
  statusName: string;
  CanClick: boolean;
  ID: number;
}


interface StatusHistory {
  statusName: string;
  CreateBy: string;
  CreateDate: string;
}